module.exports = __webpack_public_path__ + "media/images/icons/outlined/rollback-8c2dbf5d2e0ab7e72c851b6285630be2.svg";